import React from 'react';
import PropTypes from 'prop-types';

import Autosuggest from "react-autosuggest";

function ProductGeneralAutosuggest1 ({addTag, ...props}) {

    const handleOnChange = (e, {method}) => {
        if (method === 'enter') {
            e.preventDefault();
        } else {
            props.onChange(e);
        }
    };
    const renderSuggestion = (suggestion => {
        if(props.pillColumns) {
            return <span>
                {suggestion[props.nameColumn]} 
                <span style={{borderRadius: '10px', backgroundColor: '#23ccef', color: 'white', padding: '2px', float: 'right', fontSize:'12'}}>
                    {props.pillColumns.map((col) => {
                        return suggestion[col] + ' ';
                    })}
                </span>
            </span>;
        }
        return <span>{suggestion[props.nameColumn]} <span></span></span>;
    });

    let inputProps = {...props};
    delete inputProps.suggestions;
    delete inputProps.clearSuggestions;
    delete inputProps.getSuggestions;
    delete inputProps.formControl;
    if(props.formControl) {
        inputProps.className = "form-control";
    }

    return (
        <Autosuggest
            theme={theme}
            ref={props.ref}
            suggestions={props.suggestions}
            shouldRenderSuggestions={(value) => value && value.trim().length > 1}
            getSuggestionValue={(suggestion) => suggestion[props.nameColumn]}
            renderSuggestion={renderSuggestion}
            inputProps={{...inputProps, onChange: handleOnChange}}
            onSuggestionSelected={(e, {suggestion}) => {
                addTag(suggestion)
            }}
            onSuggestionsClearRequested={() => {props.clearSuggestions()}}
            onSuggestionsFetchRequested={(value) => {props.getSuggestions(value.value)}}
        />
    )
}

ProductGeneralAutosuggest1.propTypes = {
    addTag: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    pillColumns: PropTypes.arrayOf(PropTypes.string),
    nameColumn: PropTypes.string.isRequired,
    suggestions: PropTypes.array,
    clearSuggestions: PropTypes.func,
    getSuggestions: PropTypes.func,
    formControl: PropTypes.bool,
    ref: PropTypes.any
};


const theme = {
    suggestionsContainer: {
        position: "absolute",
        left: "0",
        zIndex: "10",
        background: "white",
        width: "150%",
        marginLeft: "15px",
        padding: "0"
    },

    suggestionsList: {
        listStyleType: "none",
        padding: "0",
        margin: "0",
        border: "1px solid #eeeeee",
        width: "100%"
    },

    suggestion: {
        listStyleType: "none",
        width: "100%",
        margin: "0",
        cursor: "pointer",
        padding: "8px"
    },

    suggestionHighlighted: {
        background: "#eeeeee"
    }
};

export default ProductGeneralAutosuggest1;